/* eslint-disable linebreak-style */
import {
  Box, Grid, Typography, makeStyles,
} from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';

function CallToAction() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  useEffect(() => {
    // we need to remove and reload the script to force Salsa to update the div.
    const existingScript = document.getElementById('affordabilitySalsa');
    if (existingScript) {
      document.body.removeChild(existingScript);
    }

    const salsaScript = document.createElement('script');
    salsaScript.src = 'https://default.salsalabs.org/api/widget/template/f05238bb-91eb-4d1f-81a0-b5cba5a46cce/?tId=jMWrzMRZIU';
    salsaScript.id = 'affordabilitySalsa';
    document.body.appendChild(salsaScript);

    // If we've successfully added the new Salsa Affordability CTA script to the page
    if (document.body.contains(salsaScript)) {
      // Declare (GTM))dataLayer if it doesn't exist yet, such as during local development
      window.dataLayer = window.dataLayer || [];

      // Push 'optimize.activate' event to the dataLayer after the Salsa script updates
      window.dataLayer.push({ 'event': 'optimize.activate' });
    }
  });

  return (
    <Box displayPrint="none">
      <SubquestionBox color={lightColor}>
        <Grid
          spacing={2}
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
              Call to action
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={10} sm={6}>
                <MessageBox>
                  <Box className="ccdc-salsa">
                    <Box id="jMWrzMRZIU" className="ccdc-salsa" />
                  </Box>
                </MessageBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SubquestionBox>
    </Box>
  );
}

export default CallToAction;
